// import { Contract } from "@ethersproject/contracts";
import * as XLSX from "xlsx";
import Web3 from "web3";
import Axios from "axios";
import Apiconfigs from "src/apiConfig/config";
import moment from "moment";
import { store } from "src/Redux/store";
export const CurrenyCode = [
  {
    languagename: "Hindi",
    languagetype: "hi",
    type: "Rupee",
    type1: "रुपया",
  },
  {
    languagename: "English(United States)",
    languagetype: "en",
    type: "Dollar",
    type1: "Dollar",
  },
  {
    languagename: "English",
    languagetype: "en",
    type: "Pound",
    type1: "Pound",
  },
  {
    languagename: "Chinese",
    languagetype: "zh",
    type: "Yuan/Renminbi",
    type1: "元/人民币",
  },
  {
    languagename: "Spanish",
    languagetype: "es",
    type: "Euro",
    type1: "Euro",
  },
  {
    languagename: "Russian",
    languagetype: "ru",
    type: "Ruble",
    type1: "Евро",
  },
  {
    languagename: "German",
    languagetype: "de",
    type: "Euro",
    type1: "Euro",
  },
  {
    languagename: "French",
    languagetype: "fr",
    type: "Euro",
    type1: "euro",
  },
  {
    languagename: "Italian",
    languagetype: "it",
    type: "Euro",
    type1: "Eura",
  },
  {
    languagename: "Polish",
    languagetype: "pl",
    type: "Zloty",
    type1: "złoty",
  },
  {
    languagename: "Portuguese",
    languagetype: "pt",
    type: "Euro",
    type1: "Euro",
  },
  {
    languagename: "Deutsch",
    languagetype: "nl",
    type: "Euro",
    type1: "Euro",
  },
  {
    languagename: "Indonesia",
    languagetype: "id",
    type: "Rupiah",
    type1: "Rupiah",
  },
  {
    languagename: "Romanian",
    languagetype: "ro",
    type: "Leu",
    type1: "Rupee",
  },
  ,
  {
    languagename: "Philippines",
    languagetype: "fl",
    type: "Birr",
    type1: "Rupee",
  },
  ,
  {
    languagename: "Vietnamese",
    languagetype: "vi",
    type: "Yuan",
    type1: "nhân dân tệ",
  },
  {
    languagename: "Turkish",
    languagetype: "tr",
    type: "Turkish lira (YTL)",
    type1: "Türk Lirası (YTL)",
  },
];
export const convertDateTime = (val) => {
  var tempDate = new Date(val);
  const toDateFormat = moment(tempDate).format("DD-MMM-yyyy hh:mm a");
  return toDateFormat;
};
export const map = {
  googleMapKey: "AIzaSyBpWyPnAG_3CFQC3NU0hJPt4r_IBhpsPEA",
};
export function sortAddress(add) {
  const sortAdd = `${add?.slice(0, 6)}...${add?.slice(add.length - 4)}`;
  return sortAdd;
}
export function ShortStringFunction(add) {
  if (add?.length > 25) {
    const sortAdd = `${add?.slice(0, 25)}...`;
    return sortAdd;
  } else {
    return add;
  }
}
export function sortAddress2(add) {
  const sortAdd = `${add?.slice(0, 15)}...${add?.slice(add.length - 2)}`;
  return sortAdd;
}

export function getSigner(library, account) {
  return library.getSigner(account).connectUnchecked();
}

export function getProviderOrSigner(library, account) {
  return account ? getSigner(library, account) : library;
}

// export function getContract(address, ABI, library, account) {
//   return new Contract(address, ABI, getProviderOrSigner(library, account));
// }
export const calculateTimeLeft = (endDate) => {
  if (endDate) {
    let difference = +new Date(endDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / ((1000 / 60) * 60 * 24)),
        hours: Math.floor((difference / ((1000 / 60) * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  } else {
    return false;
  }
};
export const downloadExcel = (dataToPrint, sheetName) => {
  const workSheet = XLSX.utils.json_to_sheet(dataToPrint);
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);

  XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
  XLSX.writeFile(workBook, `${sheetName}.xlsx`);
};

export const validateAccountAddress = async (account) => {
  const RPC_URL = "https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161";
  const httpProvider = new Web3.providers.HttpProvider(RPC_URL);
  const web3 = new Web3(httpProvider);
  try {
    const accountCheck = web3.utils.toChecksumAddress(account);
    if (accountCheck !== "") {
      return true;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
};
export const getBase64 = (file, cb) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(reader.result);
  };
  reader.onerror = function (err) {
    console.log("Error: ", err);
  };
};
export const resizeBase64Img = async (base64, newWidth, newHeight) => {
  return new Promise((resolve, reject) => {
    // const imageThumbnail = require("image-thumbnail");
    // const thumbnail = imageThumbnail(base64);
    // console.log("--- imageQuality --", thumbnail);
    var canvas = document.createElement("canvas");
    canvas.style.width = newWidth.toString() + "px";
    canvas.style.height = newHeight.toString() + "px";
    let context = canvas.getContext("2d");
    let img = document.createElement("img");
    img.src = base64;
    img.onload = function () {
      context.scale(newWidth / img.width, newHeight / img.height);
      context.drawImage(img, 0, 0);
      resolve(canvas.toDataURL());
    };
  });
};

export const resizeBase64Img2 = (base64, newWidth, newHeight) => {
  // return (
  var canvas = base64;
  var ctx = canvas.getContext("2d");
  // var cw=canvas.width;
  // var ch=canvas.height;
  var maxW = 324;
  var maxH = 324;

  // var input = document.getElementById('input');
  // var output = document.getElementById('file_output');
  // input.addEventListener('change', handleFiles);

  // function handleFiles(e) {
  var img = new Image();
  img.onload = function () {
    var iw = img.width;
    var ih = img.height;
    var scale = Math.min(maxW / iw, maxH / ih);
    var iwScaled = iw * scale;
    var ihScaled = ih * scale;
    canvas.width = iwScaled;
    canvas.height = ihScaled;
    ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
    let output = canvas.toDataURL("image/jpeg", 0.5);
    console.log("--- imageQuality --", output);
  };
  img.src = base64;
  // }
  // )
};
export const handleMultipleFileUpload = async (event) => {
  try {
    let res, formdata;
    formdata = new FormData();

    event.forEach((file) => {
      formdata.append("files", file);
    });

    res = await Axios({
      url: Apiconfigs.uploadMultipleFile,
      method: "POST",
      data: formdata,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          return res;
        }
      })
      .catch((error) => {
        // toast.error(error.response.message);
        return false;
      });
    return res;
  } catch (error) {
    return false;
  }
};
export const localeFunction = (key) => {
  let str = store.getState("auth");
  let langCode = str.auth.langCode;
  switch (langCode) {
    case "en":
      return require(`src/utils/lang/en`)[key];
    default:
      return require(`src/utils/lang/${langCode}`)[key];
  }
};
export const SelectLanguageTypeFunction = async (data) => {
  try {
    const res = await Axios({
      url: Apiconfigs?.setDefaultUserLanguage,
      method: "POST",
      headers: {
        token: window.sessionStorage.getItem("token"),
      },
      data: {
        languageCode: data,
      },
    });
    if (res) {
      if (res?.data?.responseCode === 200) {
        return res;
      }
    }
  } catch (error) {
    return error;
  }
};
